/* eslint-disable @typescript-eslint/no-explicit-any */
import { EmailTemplateModel } from "../../Utils/Models";
import GenericModal from "../GenericComponents/GenericModal";
import EmailTemplate from "../Templates/EmailTemplate";

type SendEmailModalProps = {
  open: boolean;
  editEmailTemplate: any;
  onClose: () => void;
  addOrUpdateEmailTemplate: (emailTemplate: EmailTemplateModel | null) => void;
};

export default function SendEmailModal(props: SendEmailModalProps) {
  const { editEmailTemplate, onClose, open, addOrUpdateEmailTemplate } = props;

  return (
    <GenericModal open={open} title="Send Email" onClose={onClose}>
      <EmailTemplate
        editEmailTemplate={editEmailTemplate}
        addOrUpdateEmailTemplate={addOrUpdateEmailTemplate}
      />
    </GenericModal>
  );
}
